function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx } from "react/jsx-runtime";
import { VisibilityOffOutlined, VisibilityOutlined } from "@mui/icons-material";
import { IconButton, Input, styled } from "@mui/material";
import { useCamelCase, useToggle } from "@vestwell-frontend/hooks";
import { format, parse, parseISO } from "date-fns";
import { forwardRef, useCallback, useEffect, useImperativeHandle, useMemo, useRef, useState } from "react";
import { NumberFormatBase, NumericFormat } from "react-number-format";
import { useUpdateEffect } from "react-use";
var isNumberAllowed = function(param) {
    var min = param.min, max = param.max;
    return function(input) {
        var isValueDefined = typeof input.floatValue === 'number';
        var isMinDefined = typeof min === 'number';
        var isMaxDefined = typeof max === 'number';
        var isAboveMin = !isMinDefined || !isValueDefined || isMinDefined && isValueDefined && input.floatValue >= min;
        var isBelowMax = !isMaxDefined || !isValueDefined || isMaxDefined && isValueDefined && input.floatValue <= max;
        return isAboveMin && isBelowMax ? input : false;
    };
};
export var maskProps = {
    currencyUs: function(param) {
        var min = param.min, max = param.max, precision = param.precision;
        return {
            allowEmptyFormatting: false,
            allowLeadingZeros: false,
            allowNegative: (min || 0) < 0,
            decimalScale: precision || 0,
            expectNumericValue: true,
            isAllowed: isNumberAllowed({
                max: max,
                min: min || 0
            }),
            prefix: '$',
            thousandSeparator: true
        };
    },
    date: function(param) {
        var dateMask = param.dateMask, dateInputFormat = param.dateInputFormat;
        return {
            allowEmptyFormatting: false,
            expectFormattedValue: true,
            format: function(value) {
                return value.replace(/\D/g, '').replace(/^(\d{2})(\d{1,2})/, '$1/$2').replace(/^(\d{2})\/(\d{2})(.+)/, '$1/$2/$3').substring(0, 10);
            },
            formatChangeValue: function(value) {
                try {
                    return value.length < dateInputFormat.length ? value : format(new Date(value), dateInputFormat);
                } catch (e) {
                    return value.length === dateInputFormat.length ? value : '';
                }
            },
            formatDisplayValue: function(value) {
                try {
                    return format(parse(value, dateInputFormat, new Date()), dateMask);
                } catch (e) {
                    return '';
                }
            },
            formatPasteValue: function(value) {
                try {
                    return format(parseISO(new Date(value).toISOString().replace('Z', '')), dateMask);
                } catch (e) {
                    return value;
                }
            },
            mask: '',
            placeholder: dateMask.toUpperCase()
        };
    },
    dateShort: function() {
        return {
            allowEmptyFormatting: false,
            expectFormattedValue: true,
            format: function(value) {
                return value.replace(/\D/g, '').replace(/^(\d{2})(\d{1,2})/, '$1/$2').substring(0, 5);
            }
        };
    },
    ein: function() {
        return {
            allowEmptyFormatting: false,
            expectFormattedValue: true,
            format: function(value) {
                return value.replace(/\D/g, '').replace(/^(\d{2})(\d{1,7})/, '$1-$2').substring(0, 10);
            },
            mask: '',
            placeholder: '##-#######'
        };
    },
    number: function(param) {
        var min = param.min, max = param.max, precision = param.precision;
        return {
            allowEmptyFormatting: false,
            allowLeadingZeros: false,
            allowNegative: (min || 0) < 0,
            decimalScale: precision || 0,
            expectNumericValue: true,
            isAllowed: isNumberAllowed({
                max: max,
                min: min || 0
            }),
            thousandSeparator: true
        };
    },
    numericString: function(param) {
        var min = param.min, max = param.max;
        return {
            allowEmptyFormatting: false,
            allowLeadingZeros: true,
            allowNegative: (min || 0) < 0,
            decimalScale: 0,
            expectNumericValue: false,
            isAllowed: isNumberAllowed({
                max: max,
                min: min || 0
            }),
            thousandSeparator: false
        };
    },
    percent: function(param) {
        var min = param.min, max = param.max, precision = param.precision, suffix = param.suffix;
        return {
            allowEmptyFormatting: false,
            allowLeadingZeros: false,
            allowNegative: (min || 0) < 0,
            decimalScale: precision || 0,
            expectNumericValue: true,
            isAllowed: isNumberAllowed({
                max: max || 100,
                min: min || 0
            }),
            suffix: suffix || '%'
        };
    },
    phoneUs: function() {
        return {
            allowEmptyFormatting: false,
            expectFormattedValue: true,
            format: function(value) {
                return value.replace(/\D/g, '').replace(/^(\d{3})(\d{1,2})/, '$1-$2').replace(/^(\d{3})-(\d{3})(.+)/, '$1-$2-$3').substring(0, 12);
            },
            mask: '',
            placeholder: '###-###-####'
        };
    },
    routing: function() {
        return {
            allowEmptyFormatting: false,
            expectFormattedValue: true,
            format: function(value) {
                return value.replace(/\D/g, '').substring(0, 9);
            },
            mask: '',
            placeholder: '#########'
        };
    },
    ssn: function() {
        return {
            allowEmptyFormatting: false,
            expectFormattedValue: true,
            format: function(value) {
                return value.replace(/\D/g, '').replace(/^(\d{3})(\d{1,2})/, '$1-$2').replace(/^(\d{3})-(\d{2})(.+)/, '$1-$2-$3').substring(0, 11);
            },
            mask: '',
            placeholder: '###-##-####'
        };
    },
    zip: function() {
        return {
            allowEmptyFormatting: false,
            expectFormattedValue: true,
            format: function(value) {
                return (value || '').length > 5 ? value.substring(0, 5) + '-' + value.substring(5) : value;
            },
            isAllowed: function(input) {
                if (!(typeof input.formattedValue === 'string' && input.formattedValue !== '')) {
                    return true;
                }
                return input.formattedValue.length >= 0 && input.formattedValue.length <= 10;
            },
            placeholder: '#####-####',
            reformatOnBlur: function(value) {
                if (value === '' || value === undefined) {
                    return '';
                }
                if ((value === null || value === void 0 ? void 0 : value.length) >= 5 && (value === null || value === void 0 ? void 0 : value.length) < 10) {
                    return value.substring(0, 5);
                }
                if ((value === null || value === void 0 ? void 0 : value.length) >= 0 && (value === null || value === void 0 ? void 0 : value.length) > 10) {
                    return value.substring(0, 10);
                }
                return value;
            }
        };
    }
};
export var TextBoxFormat = /*#__PURE__*/ forwardRef(function(_param, ref) {
    var _param_dateMask = _param.dateMask, dateMask = _param_dateMask === void 0 ? 'MM/dd/yyyy' : _param_dateMask, _param_dateInputFormat = _param.dateInputFormat, dateInputFormat = _param_dateInputFormat === void 0 ? 'yyyy-MM-dd' : _param_dateInputFormat, format = _param.format, onChange = _param.onChange, min = _param.min, max = _param.max, precision = _param.precision, placeholder = _param.placeholder, props = _object_without_properties(_param, [
        "dateMask",
        "dateInputFormat",
        "format",
        "onChange",
        "min",
        "max",
        "precision",
        "placeholder"
    ]);
    var _useMemo = useMemo(function() {
        return maskProps[format]({
            dateInputFormat: dateInputFormat,
            dateMask: dateMask,
            max: max,
            min: min,
            precision: precision,
            suffix: props.suffix
        });
    }, [
        dateInputFormat,
        dateMask,
        format,
        max,
        min,
        precision,
        props.suffix
    ]), allowEmptyFormatting = _useMemo.allowEmptyFormatting, expectFormattedValue = _useMemo.expectFormattedValue, expectNumericValue = _useMemo.expectNumericValue, formatChangeValue = _useMemo.formatChangeValue, formatDisplayValue = _useMemo.formatDisplayValue, formatPasteValue = _useMemo.formatPasteValue, reformatOnBlur = _useMemo.reformatOnBlur, inputProps = _object_without_properties(_useMemo, [
        "allowEmptyFormatting",
        "expectFormattedValue",
        "expectNumericValue",
        "formatChangeValue",
        "formatDisplayValue",
        "formatPasteValue",
        "reformatOnBlur"
    ]);
    var isDate = format === 'date';
    var _useToggle = _sliced_to_array(useToggle(false), 2), isFocused = _useToggle[0], toggleIsFocused = _useToggle[1];
    var _useState = _sliced_to_array(useState(function() {
        var _props_value, _props_value1;
        return formatDisplayValue ? formatDisplayValue((_props_value = props.value) === null || _props_value === void 0 ? void 0 : _props_value.toString()) : [
            null,
            undefined,
            ''
        ].includes((_props_value1 = props.value) === null || _props_value1 === void 0 ? void 0 : _props_value1.toString()) ? '' : props.value;
    }), 2), textValue = _useState[0], setTextValue = _useState[1];
    var onBlur = useCallback(function(e) {
        if (reformatOnBlur) {
            setTextValue(function() {
                return reformatOnBlur(e.target.value);
            });
        }
        toggleIsFocused();
        if (props.onBlur) {
            props.onBlur(e);
        }
    }, [
        props.onBlur,
        reformatOnBlur
    ]);
    var onFocus = useCallback(function(e) {
        toggleIsFocused();
        if (props.onFocus) {
            props.onFocus(e);
        }
    }, [
        props.onFocus
    ]);
    var onPaste = useCallback(function(e) {
        e.stopPropagation();
        /** prevent duplication of value */ e.preventDefault();
        setTextValue(formatPasteValue(e.clipboardData.getData('text')));
    }, [
        formatPasteValue
    ]);
    /** update the textValue when changes occur */ var onValueChange = useCallback(function(event) {
        setTextValue(function() {
            return event[expectFormattedValue ? 'formattedValue' : expectNumericValue ? 'floatValue' : 'value'];
        });
    }, [
        expectFormattedValue,
        expectNumericValue
    ]);
    var Component = useMemo(function() {
        return [
            'currencyUs',
            'number',
            'numericString',
            'percent'
        ].includes(format) ? NumericFormat : NumberFormatBase;
    }, [
        format
    ]);
    useUpdateEffect(function() {
        onChange(expectNumericValue && textValue === '' ? null : formatChangeValue ? formatChangeValue(textValue) : textValue);
    }, [
        textValue
    ]);
    /** update textValue whenever props.value is changed (external) */ useUpdateEffect(function() {
        if (!isFocused) {
            var value = [
                null,
                undefined,
                ''
            ].includes(props.value) ? '' : props.value;
            setTextValue(function() {
                return formatDisplayValue ? formatDisplayValue(value) : value;
            });
        }
    }, [
        props.value,
        isDate,
        dateMask
    ]);
    return /*#__PURE__*/ _jsx(Component, _object_spread_props(_object_spread({
        "data-raw-value": props.value
    }, props, inputProps), {
        getInputRef: ref,
        onBlur: onBlur,
        onFocus: onFocus,
        onPaste: formatPasteValue ? onPaste : undefined,
        onValueChange: onValueChange,
        placeholder: placeholder || inputProps.placeholder,
        value: textValue,
        valueIsNumericString: typeof props.value === 'string' && /^\d*\.?\d*$/.test(textValue)
    }));
});
TextBoxFormat.displayName = 'TextBoxFormat';
var StyledInput = styled(Input, {
    shouldForwardProp: function(prop) {
        return prop !== 'align';
    }
})(function(props) {
    return _object_spread_props(_object_spread({
        '& input': _object_spread({}, props['data-secure'] && {
            WebkitTextSecurity: 'disc'
        })
    }, props.variant === 'large' && {
        fontSize: props.theme.spacing(10)
    }), {
        textAlign: props.align ? props.align : undefined
    });
});
export var TextBox = /*#__PURE__*/ forwardRef(function(_param, ref) {
    var align = _param.align, _param_autoComplete = _param.autoComplete, autoComplete = _param_autoComplete === void 0 ? 'off' : _param_autoComplete, _param_autoFocus = _param.autoFocus, autoFocus = _param_autoFocus === void 0 ? false : _param_autoFocus, className = _param.className, disabled = _param.disabled, endAdornment = _param.endAdornment, label = _param.label, _param_noFocusStyle = _param.noFocusStyle, noFocusStyle = _param_noFocusStyle === void 0 ? false : _param_noFocusStyle, readOnly = _param.readOnly, required = _param.required, _param_revealable = _param.revealable, revealable = _param_revealable === void 0 ? false : _param_revealable, _param_type = _param.type, type = _param_type === void 0 ? 'text' : _param_type, _param_variant = _param.variant, variant = _param_variant === void 0 ? 'small' : _param_variant, width = _param.width, props = _object_without_properties(_param, [
        "align",
        "autoComplete",
        "autoFocus",
        "className",
        "disabled",
        "endAdornment",
        "label",
        "noFocusStyle",
        "readOnly",
        "required",
        "revealable",
        "type",
        "variant",
        "width"
    ]);
    var testId = useCamelCase(props.name);
    var _useToggle = _sliced_to_array(useToggle(false), 2), reveal = _useToggle[0], toggleReveal = _useToggle[1];
    var $input = useRef(null);
    useImperativeHandle(ref, function() {
        return $input.current;
    });
    useEffect(function() {
        var timeout = setTimeout(function() {
            if (autoFocus) {
                $input.current.focus();
                $input.current.select();
            }
        }, 10);
        return function() {
            clearTimeout(timeout);
        };
    }, []);
    var onPaste = useCallback(function(e) {
        if (props.onPaste) {
            return props.onPaste(e);
        }
        e.stopPropagation();
        e.preventDefault();
        props.onChange(e.clipboardData.getData('text').trim());
    }, [
        props.onChange,
        props.onPaste
    ]);
    var isMask = props.format && props.format !== 'email';
    var _props_value;
    return /*#__PURE__*/ _jsx(StyledInput, {
        align: align,
        className: className,
        "data-no-focus-style": noFocusStyle,
        "data-secure": !!revealable && type !== 'password' && !reveal,
        disabled: !!disabled,
        endAdornment: revealable ? /*#__PURE__*/ _jsx(IconButton, {
            "aria-label": "".concat(reveal ? 'Hide' : 'Show').concat(label || props.name ? " ".concat(label || props.name) : ''),
            "aria-pressed": reveal,
            className: "p-0 mr-2",
            "data-component": "textFieldRevealButton",
            "data-testid": testId,
            onClick: toggleReveal,
            onMouseDown: toggleReveal,
            children: reveal ? /*#__PURE__*/ _jsx(VisibilityOffOutlined, {
                fontSize: "small"
            }) : /*#__PURE__*/ _jsx(VisibilityOutlined, {
                fontSize: "small"
            })
        }) : endAdornment,
        inputComponent: isMask ? TextBoxFormat : undefined,
        inputProps: _object_spread_props(_object_spread({}, props), {
            'aria-disabled': !!disabled,
            'aria-live': 'polite',
            'aria-required': !!required,
            autoComplete: props.name === 'password' ? reveal ? 'off' : autoComplete : autoComplete,
            autoFocus: autoFocus,
            'data-component': 'textFieldInput',
            'data-testid': testId,
            onChange: isMask ? props.onChange : function(e) {
                return props.onChange(e.target.value);
            },
            onPaste: props.format === 'email' ? onPaste : props.onPaste,
            type: revealable && type === 'password' ? reveal ? 'text' : 'password' : type
        }),
        inputRef: $input,
        readOnly: readOnly,
        required: !!required,
        sx: function(theme) {
            return {
                width: width ? theme.spacing(width) : undefined
            };
        },
        value: (_props_value = props.value) !== null && _props_value !== void 0 ? _props_value : '',
        variant: variant
    });
});
TextBox.displayName = 'TextBox';

//# sourceMappingURL=TextBox.js.map